/**
 * Radii Primitives
 * Standard border-radius values.
 */
export const radii = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  "2xl": 24,
  "3xl": 32,
  full: 50,
} as const;

export const radiiV2 = {
  14: 14,
  18: 18,
  20: 20,
  28: 28,
  40: 40,
} as const;
